import { render, staticRenderFns } from "./AccordionArrow.vue?vue&type=template&id=78a4266d&scoped=true&"
import script from "./AccordionArrow.vue?vue&type=script&lang=js&"
export * from "./AccordionArrow.vue?vue&type=script&lang=js&"
import style0 from "./AccordionArrow.vue?vue&type=style&index=0&id=78a4266d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a4266d",
  null
  
)

export default component.exports